import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconBacklinkChecker(rest) {
  return (
    <Icon viewBox="0 0 32 32" {...rest}>
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1}
        transform="matrix(1,0,0,1,3.32108,2.29313)"
      >
        <g transform="matrix(1,0,0,1,-3.13154,-2.31847)">
            <path d="M11.857,10.383C11.857,10.383 11.64,10.6 11.31,10.93C9.555,12.685 9.555,15.53 11.31,17.284C11.311,17.286 11.313,17.287 11.314,17.289C13.075,19.05 15.93,19.05 17.691,17.289C19.174,15.806 20.932,14.048 22.414,12.566C23.258,11.722 23.732,10.578 23.732,9.384C23.732,8.191 23.258,7.046 22.414,6.202C22.413,6.202 22.412,6.201 22.412,6.2C20.652,4.441 17.799,4.441 16.039,6.2C15.762,6.478 15.584,6.656 15.584,6.656"/>
        </g>
        <g transform="matrix(1,0,0,1,-5.2361,6.2422)">
            <path d="M11.857,10.383C11.857,10.383 11.64,10.6 11.31,10.93C9.555,12.685 9.555,15.53 11.31,17.284C11.311,17.286 11.313,17.287 11.314,17.289C13.075,19.05 15.93,19.05 17.691,17.289C19.174,15.806 20.932,14.048 22.414,12.566C23.258,11.722 23.732,10.578 23.732,9.384C23.732,8.191 23.258,7.046 22.414,6.202C22.413,6.202 22.412,6.201 22.412,6.2"/>
        </g>
        <g transform="matrix(1,0,0,1,-3.13154,-2.31847)">
            <path d="M13.244,6.515L13.244,8.995L15.727,8.995"/>
        </g>
      </g>
    </Icon>
  )
}